<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">地图定位</span>
    </p>
    <div style="position: relative;">
      <div style="font-size: 9pt; margin-bottom: 10px">
        标注地点：
        <span v-if="marked">{{ location.address }} ({{ location.lng }}, {{ location.lat }})</span>
        <span v-else>NA</span>
      </div>
      <div class="map">
        <baidu-map
          class="bmView"
          :scroll-wheel-zoom="true"
          :center="center"
          :zoom="zoom"
          :style="'height:' + height + 'px'"
          @click="getLocationPoint"
          @ready="onMapReady"
        >
          <bm-view style="width: 100%; height:100%; " />
          <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
          </bm-marker>
          <bm-control :offset="{width: '10px', height: '10px'}">
            <bm-auto-complete v-model="keyword" :sug-style="{zIndex: 999999}">
              <input type="text" placeholder="请输入地址..." class="serachinput" style="margin: 5px; width: 200px; font-size: 9pt;">
            </bm-auto-complete>
          </bm-control>
          <bm-local-search :keyword="keyword" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;" />
          <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :show-address-bar="true" :auto-location="true" />
        </baidu-map>
      </div>
    </div>
    <div slot="footer">
      <Button type="primary" size="small" icon="ios-checkmark-circle-outline" @click="submit">
        确定
      </Button>
    </div>
  </Modal>
</template>

<script>
import { BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker, BmNavigation, BmGeolocation } from 'vue-baidu-map'
export default {
  name: 'VBaiduMap',
  components: { BaiduMap, BmControl, BmView, BmLocalSearch, BmAutoComplete, BmMarker, BmNavigation, BmGeolocation },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 650
    },
    height: {
      type: Number,
      default: 350
    },
    data: {
      type: Object,
      default() { return {} }
    }
  },
  data() {
    return {
      center: {}, // { lng: 116.404, lat: 39.915 },
      zoom: 12.8,
      keyword: '',
      location: {},
      marked: false
    }
  },
  computed: {
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    data(val) {
      if (val) {
        this.location = val
        this.center = { lng: val.lng, lat: val.lat }
        this.marked = true
      }
    }
  },
  methods: {
    onMapReady({ BMap, map }) {
      const _this = this
      const geoLocation = new BMap.Geolocation()
      if (this.data && this.data.lng && this.data.lat) {
        // location initialized
      } else {
        geoLocation.getCurrentPosition(function(r) {
          _this.center = { lng: r.longitude, lat: r.latitude }
        }, { enableHighAccuracy: true })
      }
    },
    getLocationPoint(e) {
      const _this = this
      const { lng, lat } = e.point
      const geoCoder = new BMap.Geocoder()
      geoCoder.getPoint(this.addressKeyword, point => {
        this.selectedLng = point.lng
        this.selectedLat = point.lat
      })
      geoCoder.getLocation(e.point, res => {
        _this.marked = true
        _this.center = { lng: lng, lat: lat }
        _this.location = { lng: lng, lat: lat, address: res.address }
      })
    },
    submit() {
      if (!this.marked) {
        this.$Notice.error({ title: '请标注地图位置..' })
      } else {
        this.$emit('on-marked', this.location)
      }
    },
    closeModal() {
      this.marked = false
      this.$emit('on-close')
    }
  }
}
</script>
